










helpers = require('../../helpers.coffee')

view_model =
  components:
    templateForm: require('./form')

  data: ->
    template: new Template(signature: Session.current_user.signature)
    from_library: false

  methods:
    loadTemplate: ->
      Loader.on()
      id = @$route.params.template_id
      @templates_resource.get(@loadTemplateSuccess, @unknownError, {id})

    loadTemplateSuccess: (resource) ->
      @from_library = true
      Loader.off()
      template = resource.template
      @template = new Template
        name: template.name
        template_category_id: template.template_category_id
        subject: template.subject
        body: template.body
        parent_id: template.id
        signature: Session.current_user.signature

    save: ->
      @templates_resource.create(@saveSuccess, @unknownError, @template)

    saveSuccess: (response) ->
      Loader.off()
      @$router.push('/templates')
      template = if response.data then response.data.template else response.template
      alertify.success this.$t('template.feedback.createSuccess')
      @trackIntercomEvent(response) if response

    trackIntercomEvent: (response) ->
      template = if response.data then response.data.template else response.template
      action = if @from_library then 'Novo a partir da biblioteca' else this.$t('general.actions.new')
      metadata = [
        { value: "#{location.href}/#{template.id}/editar", key: this.$t('template.label.templateURL') }
        { attribute: 'body', key: this.$t('template.label.imagesContentLength'), function: 'htmlImgTagQuantity' },
        { attribute: 'body', key: this.$t('template.label.hiperlinksContentLength'), function: 'htmlATagQuantity' },
        { attribute: 'signature', key: this.$t('template.label.imagesSignatureLength'), function: 'htmlImgTagQuantity' },
        { attribute: 'signature', key: this.$t('template.label.hiperlinksSignatureLength'), function: 'htmlATagQuantity' }
      ]
      IntercomCtrl.trackEventMetadata('Template - ' + action, metadata, null, template)

  created: ->
    @templates_resource = new TemplatesResource(Session.current_company.id)
    @loadTemplate() if @$route.params.template_id

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/new.vue